<app-mobile-app-bar eyebrow="Memoria Bibliográfica" [title]="title" [leadingIcon]="null">
    <div class="m-dashboard-actions">
        @if (toastDelivery$ | async; as toastDelivery) {
            @if (!layout.state().isMedium && (notificationsEnabled || toastDelivery.requested)) {
                <app-notification-bell placement="navbar"></app-notification-bell>
            }
        }
        <a class="m-dashboard-actions__button" [class.has-unread-messages]="unreadChatCount > 0" routerLink="/dashboard/profile"
            [attr.aria-label]="unreadChatCount > 0 ? 'Abrir perfil, ' + unreadChatCount + ' mensajes sin leer' : 'Abrir perfil'" (click)="closeMore()">
            <img [src]="imageUrl" alt="" (error)="imageError.emit($event)">
        </a>
    </div>
</app-mobile-app-bar>

<app-mobile-navigation [active]="activeDestination" [communityEnabled]="communityEnabled"
    [moreOpen]="moreOpen" [imageUrl]="imageUrl" [unreadChatCount]="unreadChatCount"
    (imageError)="imageError.emit($event)" (moreRequested)="toggleMore()"></app-mobile-navigation>

@if (moreOpen) {
    <div class="m-more-backdrop" data-native-back-overlay [class.is-closing]="moreSheetClosing" (click)="closeMore()">
        <aside id="mobile-more-panel" class="m-more-sheet m-sheet" [class.is-dragging]="moreSheetDragging"
            [class.is-closing]="moreSheetClosing"
            [style.transform]="moreSheetClosing ? null : 'translateY(' + moreSheetDragOffset + 'px)'"
            (click)="$event.stopPropagation()" aria-label="Más destinos">
            <div class="m-more-sheet__handle" aria-hidden="true"
                (pointerdown)="startMoreSheetDrag($event)" (pointermove)="moveMoreSheetDrag($event)"
                (pointerup)="finishMoreSheetDrag($event)" (pointercancel)="cancelMoreSheetDrag($event)"><span></span></div>
            <header class="m-more-sheet__profile">
                <img [src]="imageUrl" alt="" (error)="imageError.emit($event)">
                <div>
                    <span>Tu espacio</span>
                    <strong>{{ user.displayName || user.name }}</strong>
                </div>
                <button class="m-icon-button" type="button" data-native-back-action aria-label="Cerrar" (click)="closeMore()"><mat-icon>close</mat-icon></button>
            </header>

            <nav class="m-more-sheet__links">
                <a routerLink="/dashboard/profile" routerLinkActive="is-active" (click)="closeMore()"><mat-icon>person</mat-icon><span>Perfil</span></a>
                <a routerLink="/dashboard/account-security" routerLinkActive="is-active" (click)="closeMore()"><mat-icon>shield</mat-icon><span>Cuenta y seguridad</span></a>
                <a routerLink="/dashboard/preferences" routerLinkActive="is-active" (click)="closeMore()"><mat-icon>settings</mat-icon><span>Preferencias</span></a>
                <a routerLink="/dashboard/statistics" routerLinkActive="is-active" (click)="closeMore()"><mat-icon>bar_chart</mat-icon><span>Estadísticas</span></a>
                @if (chatEnabled) {
                    <button type="button" (click)="openChat()"><mat-icon>forum</mat-icon><span>Mensajes</span></button>
                }
            </nav>

            <section class="m-more-sheet__theme" aria-label="Apariencia">
                <div><strong>Tema</strong><span>{{ mobileTheme.theme() === 'dark' ? 'Oscuro' : 'Claro' }}</span></div>
                <button class="m-theme-switch" type="button" [class.is-dark]="mobileTheme.theme() === 'dark'"
                    [attr.aria-pressed]="mobileTheme.theme() === 'dark'" [attr.aria-label]="mobileTheme.actionLabel"
                    [disabled]="mobileTheme.saving()" (click)="mobileTheme.toggle()">
                    <i aria-hidden="true"></i><mat-icon aria-hidden="true">light_mode</mat-icon><mat-icon aria-hidden="true">dark_mode</mat-icon>
                </button>
            </section>

        </aside>
    </div>
}
